export function payWithPaystack({
  publicKey,
  email,
  amount,
  reference,
  onSuccess,
  onClose,
}) {
  const handler = window.PaystackPop.setup({
    key: publicKey,
    email,
    amount: amount * 100,

    // 🔥 THIS IS THE MOST IMPORTANT LINE
    ref: reference,

    callback: function (response) {
      onSuccess(response);
    },
    onClose,
  });

  handler.openIframe();
}
